module.exports = __webpack_public_path__ + "static/media/mypage.4c16bfb9.svg";